<script setup lang="ts">
import {
	RuleDimension,
	TimeRangeItem,
} from "@/modules/rule_engine/ruleEngineClasses";
import TimeRange from "@/modules/rule_engine/components/ui/TimeRange.vue";
import { ref } from "vue";

/**
 * The dimension is unused here — the picker above already names it — but every
 * condition editor is mounted with the same props.
 */
defineProps<{
	selectedRuleDimension: RuleDimension;
}>();

const selection = defineModel<TimeRangeItem[]>();
defineModel<boolean>("isInputValid", {
	default: () => ref(true),
});
</script>

<template>
	<time-range v-model="selection" />
</template>
